// The restore scope is fixed by the entry point the user clicked inside the user
// view, so the wizard never asks for it: the whole user, or one of the two
// workloads on its own.
export type Microsoft365UserRestoreScope =
  'wholeUser' | 'onedrive' | 'exchange';

export const scopeLabels: Record<Microsoft365UserRestoreScope, string> = {
  wholeUser: 'Exchange + OneDrive',
  onedrive: 'OneDrive only',
  exchange: 'Exchange only',
};
